import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom'; // react-router-dom에서 useHistory 임포트

interface AudioPlayerProps {
	src: string;
	isPlaying: boolean;
	onPlay: (src: string) => void;
	onEnded: () => void;
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({ src, isPlaying, onPlay, onEnded }) => {
	const audioRef = useRef<HTMLAudioElement | null>(null);

	const history = useHistory(); // 라우터 history 객체

	// 오디오 객체를 초기화하고 이벤트 리스너를 설정합니다.
	useEffect(() => {
		if (audioRef.current) {
			audioRef.current.pause();
			audioRef.current.src = '';
		}

		const audio = new Audio(src);
		audioRef.current = audio;

		const handleLoad = () => {
			if (isPlaying) {
				audio.play().catch((error: Error) => console.log('Playback was prevented:', error));
			}
		};

		const handleEnded = () => {
			if (onEnded) onEnded();
		};

		audio.addEventListener('loadeddata', handleLoad);
		audio.addEventListener('ended', handleEnded);

		return () => {
			audio.removeEventListener('loadeddata', handleLoad);
			audio.removeEventListener('ended', handleEnded);
			audio.pause();
		};
	}, [src]);

	// 재생 상태를 관리합니다.
	useEffect(() => {
		const audio = audioRef.current;
		if (audio) {
			if (isPlaying) {
				audio.play().catch((error: Error) => console.log('Playback was prevented:', error));
			} else {
				audio.pause();
				audio.currentTime = 0;
			}
		}
	}, [isPlaying]);

	// 라우트 변경 감지
	useEffect(() => {
		return history.listen((location, action) => {
			if (action === 'POP') {
				console.log('Navigating back, stopping music.');
				if (audioRef.current) {
					audioRef.current.pause();
					audioRef.current.currentTime = 0;
				}
			}
		});
	}, [history]);

	return (
		<div>
			<button onClick={() => onPlay(src)} style={{ border: 'none', background: 'none', width: '50px' }}>
				{isPlaying ? <img src="../images/pause_button.png" style={{ width: '100%' }} alt="Pause" /> : <img src="../images/play_button.png" style={{ width: '100%' }} alt="Play" />}
			</button>
		</div>
	);
};

export default AudioPlayer;
